"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get deserializeJSON () {
        return deserializeJSON;
    },
    get serializeJSON () {
        return serializeJSON;
    }
});
const serializeJSON = (data)=>{
    // if already in string format ignore stringify
    if (typeof data === 'string') {
        return data;
    }
    return JSON.stringify(data);
};
const deserializeJSON = (data)=>{
    // if already in object format ignore parse
    if (typeof data === 'object') {
        return data != null ? data : {};
    }
    try {
        var _JSON_parse;
        return (_JSON_parse = JSON.parse(data)) != null ? _JSON_parse : {};
    } catch (e) {
        return {};
    }
};
